import { PageWithTitle } from 'src/shared/components/PageWithTitle';
import { useTranslation } from 'react-i18next';
import { INTEGRATIONS_V2, type INTEGRATIONS } from './components/IntegrationButton';
import Integration from './pages/Integration';
import { IntegrationsList } from './pages/IntegrationsList';
import { Form } from 'react-final-form';
import { noop } from 'lodash';
import { factorialInitialValues } from './pages/components/integrations2.0/Factorial/utils';
import { useIntegrations } from './hooks';
import { IntegrationsActions } from './components/IntegrationsActions';
import { a3InitialValues } from './pages/components/integrations2.0/A3/utils';
import { castillaInitialValues } from './pages/components/integrations2.0/Castilla/utils';
import { bukInitialValues } from './pages/components/integrations2.0/Buk/utils';
import { bizneoInitialValues } from './pages/components/integrations2.0/Bizneo';

type IntegrationsProps = {
  integrationNameSource: INTEGRATIONS | INTEGRATIONS_V2;
};

const integration20InintialValues = {
  [INTEGRATIONS_V2.FACTORIAL]: factorialInitialValues,
  [INTEGRATIONS_V2.A3API]: a3InitialValues,
  [INTEGRATIONS_V2.PERSONIO]: a3InitialValues,
  [INTEGRATIONS_V2.CASTILLA]: castillaInitialValues,
  [INTEGRATIONS_V2.BUK]: bukInitialValues,
  [INTEGRATIONS_V2.BIZNEO]: bizneoInitialValues
};

const getInitialValues = (integrationName: INTEGRATIONS | INTEGRATIONS_V2 | 'none') => {
  if (Object.values(INTEGRATIONS_V2).find(v2Integration => v2Integration === integrationName)) {
    return integration20InintialValues[integrationName as INTEGRATIONS_V2];
  }

  return {};
};

export const Integrations = ({ integrationNameSource }: IntegrationsProps) => {
  const { t } = useTranslation(['settings', 'common']);
  const pageTitle = t('integrations.integrations');
  const pageSubtitle = t('integrations.default header');
  const { integrationName, setIntegrationName, handleSubmit } = useIntegrations(integrationNameSource);

  return (
    <Form onSubmit={noop} initialValues={getInitialValues(integrationName)}>
      {() => (
        <PageWithTitle
          title={pageTitle}
          subTitleContent={
            <IntegrationsActions
              pageSubtitle={pageSubtitle}
              integrationNameSource={integrationNameSource}
              handleSubmit={handleSubmit}
            />
          }
          contentWrapperProps={{ sx: { padding: '48px 64px' } }}
        >
          {integrationNameSource ? (
            <Integration
              integrationName={integrationName}
              setIntegrationName={setIntegrationName}
              handleSubmit={handleSubmit}
            />
          ) : (
            <IntegrationsList />
          )}
        </PageWithTitle>
      )}
    </Form>
  );
};
